<script>
    export let url = null;
    export let title = "";
    export let classname = "def-iframe";
    export let height = "300px";
</script>

<iframe style="height:{height}" {title} class={classname} src="{url}"></iframe>

<style>
    .def-iframe {
        height:300px;
        width:100%;
        border:1px solid #ccc
    }
</style>
